import "@mdxeditor/editor/style.css";
import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CodeToggle,
  CreateLink,
  InsertCodeBlock,
  MDXEditorMethods,
  InsertImage,
  InsertTable,
  InsertThematicBreak,
  ListsToggle,
  MDXEditor,
  UndoRedo,
  codeBlockPlugin,
  codeMirrorPlugin,
  headingsPlugin,
  imagePlugin,
  linkDialogPlugin,
  linkPlugin,
  markdownShortcutPlugin,
  tablePlugin,
} from "@mdxeditor/editor";
import { listsPlugin } from "@mdxeditor/editor";
import { quotePlugin } from "@mdxeditor/editor";
import { thematicBreakPlugin, toolbarPlugin } from "@mdxeditor/editor";
import { useAddFileUrlMutation } from "src/services/FileExplorer";
import { IMAGE_BASE_URL } from "src/utils/constants";
import React, { useEffect } from "react";
import { ErrorMessage } from "formik";

type Props = {
  onChange: (html: any) => void;
  value: any;
  name?: any;
  label?: string;
  required?: boolean;
  placeholder?: string;
  readOnly?:boolean ;
  extraClasses?:string ;
};

const ATMHTMLEditor = ({
  value,
  name,
  onChange,
  label,
  required = false,
  placeholder,
  extraClasses ,
  readOnly = false,
}: Props) => {
  const [fileUpload] = useAddFileUrlMutation();
  const ref = React.useRef<MDXEditorMethods>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current?.setMarkdown(value);
    }
  }, [value]);
  return (
    <div className="relative">
      {label && (
        <label className="font-medium text-slate-700">
          {" "}
          {label} {required && <span className="text-red-500"> * </span>}{" "}
        </label>
      )}
      <MDXEditor
      placeholder={placeholder}
        ref={ref}
        readOnly={readOnly}
        markdown={value}
        onChange={(markdown) => onChange(markdown)}
        contentEditableClassName="prose"
        className={`${extraClasses} mt-1 bg-white border rounded-md"`}
        plugins={[
          headingsPlugin(),
          linkDialogPlugin(),
          linkPlugin(),
          listsPlugin(),
          tablePlugin(),
          quotePlugin(),
          codeBlockPlugin({ defaultCodeBlockLanguage: "js" }),
          codeMirrorPlugin({
            codeBlockLanguages: { js: "JavaScript", css: "CSS" },
          }),
          markdownShortcutPlugin(),
          thematicBreakPlugin(),
          imagePlugin({
            disableImageResize: true,
            imageUploadHandler: async (image) => {
              const formData = new FormData();
              formData.append("bucketName", "GEEKSDOOR_ADMIN");
              formData.append("file", image, image?.name);
              const response: any = await fileUpload(formData);
              return `${IMAGE_BASE_URL}/${response?.data?.file_path}`;
            },
          }),

          toolbarPlugin({
            toolbarContents: () => (
              <>
                <>
                  <UndoRedo />
                </>
                <BoldItalicUnderlineToggles />
                <BlockTypeSelect />
                <CodeToggle />
                <CreateLink />
                <InsertCodeBlock />
                <InsertImage />
                <InsertTable />
                <InsertThematicBreak />
                <ListsToggle />
              </>
            ),
          }),
        ]}
      />
      {name && (
        <ErrorMessage name={name}>
          {(errMsg) => (
            <p className="font-poppins absolute text-[14px] text-start mt-0 text-red-500">
              {" "}
              {errMsg}{" "}
            </p>
          )}
        </ErrorMessage>
      )}
    </div>
  );
};

export default ATMHTMLEditor;
